import { gql } from "utils/urql";
import { ArticleDatelineFragment } from "types/api";
import { formatArticleDate } from "utils/date";
import styles from "./ArticleDateline.module.scss";
import cx from "classnames";

const ArticleDateline = ({
  datePublished,
  ...props
}: ArticleDatelineFragment) => {
  return (
    <>
      <time
        className={cx(
          styles.root,
          props.primaryChannel?.slug === "ideas" && styles.ideasRoot
        )}
        dateTime={datePublished || undefined}
      >
        {props.__typename === "MagazineArticle" && props.issue ? (
          <a
            className={styles.link}
            href={props.issue.url}
            data-action="click link - magazine issue"
            data-label={props.issue.url}
          >
            {props.issue.issueName} Issue
          </a>
        ) : (
          formatArticleDate(datePublished)
        )}
      </time>
    </>
  );
};

export default ArticleDateline;

ArticleDateline.fragment = gql`
  fragment articleIssue on MagazineArticle {
    issue {
      url
      issueName
    }
  }
  fragment articleDateline on Article {
    dateModified
    datePublished
    primaryChannel {
      slug
    }

    ... on MagazineArticle {
      ...articleIssue
    }
  }
`;
